import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tfagency-error-message',
  imports: [CommonModule, MatButtonModule, TranslateModule],
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent {
  @Input() errorMessage = '';
  @Output() retry = new EventEmitter();

  reload() {
    this.retry.emit();
  }
}
